export const maskTypesMixin = {
  data() {
    return {
      maskTypes: []
    };
  },

  created() {
    this.getMaskTypes();
  },

  methods: {
    getMaskTypes() {
      let listName = "list_mask_type";
      let maskTypes = this.$store.getters.getListOfOptionsByListName(listName);
      if (maskTypes === undefined) {
        this.$store.dispatch("GET_LIST", { listName: listName }).then(list => {
          this.maskTypes = list;
        });
      } else {
        this.maskTypes = maskTypes;
      }
    },

    getMaskType(maskTypeID) {
      return this.maskTypes.find(maskType => maskType.code == maskTypeID);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/forms/masks/maskTypesMixin.js